import L from 'leaflet';
import credentials from 'config/credentials';
import request from '../request';
import { NOMIN_REVERSE, OPENCAGE } from './constants';

export function* reverseNomin(loc, locale = 'nl') {
  const options = {
    lat: loc.lat,
    lon: loc.lng,
    format: 'json',
    'accept-language': locale,
  };
  const url = `${NOMIN_REVERSE}${L.Util.getParamString(options)}`;
  try {
    const result = yield request(url);
    return result.address;
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
    return null;
  }
}

export function* reverseOpenCage(loc, locale = 'nl') {
  const options = {
    q: `${loc.lat},${loc.lng}`,
    language: locale,
    address_only: 1,
    limit: 1,
    no_annotations: 1,
    key: credentials.opencage,
  };
  const url = `${OPENCAGE}${L.Util.getParamString(options)}`;
  try {
    const result = yield request(url);
    return result.results[0].components;
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
    return null;
  }
}

function* reverse(loc, locale = 'nl') {
  return (
    (yield reverseOpenCage(loc, locale)) || (yield reverseNomin(loc, locale))
  );
}

export default reverse;
